import React, { useCallback } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { Ballad } from '@digimap/types'
import FilterableBalladsMapList from './components/FilterableBalladsMapList'

interface HomeBalladsContainerProps
  extends RouteComponentProps<{
    balladType: 'hike' | 'ride' | undefined
  }> {}

export default function HomeBalladsContainer(props: HomeBalladsContainerProps) {
  const onBalladClickMemo = useCallback(
    (ballad: Ballad) => {
      props.history.push(`/ballads/${ballad._id}`)
    },
    [props.history]
  )

  return (
    <FilterableBalladsMapList
      onBalladClick={onBalladClickMemo}
      balladType={props.match.params.balladType}
      showIfCompleted={true}
      showOnlyIfRouted={true}
    />
  )
}
